import React, { PureComponent } from 'react'
import styled from 'styled-components';
import GlobalStyle from 'stylecomponents/globalstyle';
import NewProductsSideBarView from 'components/newproducts/commons/NewProductsSideBarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';
import VitemProductListItem from 'components/vitemproducts/commons/VitemProductListItem';
import CupoyRouter from 'components/commons/router/CupoyRouter';
import productUtil, { PRODUCT_COVER_SIZE } from 'util/productUtil';

const Container = GlobalStyle.SubContainer.extend`
  display: grid;
  grid-template-columns: 1fr 244px;
  grid-template-rows: auto auto;
  grid-gap: ${GlobalStyle.ViewSpace}px;
  margin-top: ${props => props.marginTop? GlobalStyle.ViewSpace:0}px;
`

const StatusContainer = GlobalStyle.BasicBlock.extend`
    margin-bottom: ${GlobalStyle.ViewSpace}px;
`;

const Main = styled.div`
`

const GridContainer = styled.div`
  display: grid;
  justify-items: center;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(3, 1fr);
`

class VitemProductsView extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      isEmpty: false,
    };
  }

  componentDidMount() {
    window.scrollTo({ top: 0 });

    const { vitemProductIds } = this.props;
    if(Array.isArray(vitemProductIds) && vitemProductIds.length === 0){
      this.props.cardActions.listVitemProducts().then(()=>{
        const {vitemProductIds} = this.props;
        if(Array.isArray(vitemProductIds) && vitemProductIds.length === 0){
          this.setState({
            isEmpty: true,
          });
        }
      });
    }
  }

  routeToContent = id => {
    this.props.webActions.cupoyStateGo(CupoyRouter.STATES.VITEM_PRODUCT, { id });
  }

  addCart = (productid, routeToCart = false, event) => {
    event.stopPropagation();
    this.props.webActions.openAddProductDialog({ productid, routeToCart });
  }

  render() {

    const {
      vitemProductIds = [],
      cardProductMap,
    } = this.props;

    return (
      <Container>
        <Main>
          <GridContainer>
            {
              vitemProductIds.map((id, index) => {

                const vitem = cardProductMap[id];

                const {
                  productid,
                  thumbimg,
                  productname = '',
                  // marketprice,
                  memberprice = 0,
                  hottag,
                  updatetime,
                } = vitem;

                const imageSrc = productUtil.getProductCover(PRODUCT_COVER_SIZE.LARGE, productid, thumbimg, updatetime);

                return (
                  <VitemProductListItem
                    key={id}
                    id={productid}
                    price={memberprice}
                    imageSrc={imageSrc}
                    name={productname.trim()}
                    isHot={hottag}
                    needMarginRight={(index + 1) % 4 !== 0}
                    addCart={this.addCart}
                    routeToContent={this.routeToContent}
                  />
                );
              })
            }
          </GridContainer>
          {this.props.isloading ?
            <GlobalStyle.LoadingContainer>
              <GlobalStyle.Spin />
            </GlobalStyle.LoadingContainer>
            :
            null
          }
          {this.props.error ?
            <StatusContainer>
              <GlobalStyle.ErrorContainer>
                <GlobalStyle.ErrorContainerTitle>
                  發生錯誤
                </GlobalStyle.ErrorContainerTitle>
                <GlobalStyle.ErrorContainerDesription>
                  無法取得商品列表，請重新整理後再嘗試。
                </GlobalStyle.ErrorContainerDesription>
              </GlobalStyle.ErrorContainer>
            </StatusContainer>
            :
            null
          }
          {this.state.isEmpty ?
            <StatusContainer>
              <GlobalStyle.ErrorContainer>
                <GlobalStyle.ErrorContainerTitle>
                  查無資料
                </GlobalStyle.ErrorContainerTitle>
                <GlobalStyle.ErrorContainerDesription>
                  目前此類查無商品
                </GlobalStyle.ErrorContainerDesription>
              </GlobalStyle.ErrorContainer>
            </StatusContainer>
            :
            null
          }
        </Main>
        <NewProductsSideBarView />
      </Container>
    )
  }
}

/*--------------------------
    Reducer Props
--------------------------*/
const mapStateToProps = function(state) {
  return {
    haslogin: state.member.haslogin,
    cardProductMap: state.card.cardProductMap,
    vitemProductIds: state.card.vitemProductIds,

    isloading: state.card.isloading,
    error: state.card.error,
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function(dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
    cardActions: bindActionCreators(actionCreators.cardActionCreators, dispatch),
    cardCartActions: bindActionCreators(
      actionCreators.cardCartActionCreators,
      dispatch,
    ),
  };
};

/*--------------------------
  export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(VitemProductsView);
